import path = require("path");
import * as React from "react";
import "../../../../../../contentManager/Home/ContentHome.css";
import {
  SelectionMode,
  Selection,
  DetailsListLayoutMode,
  IColumn,
  ConstrainMode,
  CommandBar,
  ICommandBarItemProps,
  ScrollablePane,
  ScrollbarVisibility,
  mergeStyleSets,
  ICommandBarStyles,
  DetailsRow,
  IDetailsListProps,
  ShimmeredDetailsList,
  IGroup,
  ContextualMenuItemType,
  IContextualMenuItem,
  IDetailsRowStyles,
  Spinner,
  SpinnerSize,
  IContextualMenuItemProps,
  IRenderFunction,
  Point,
  IContextualMenuProps,
  DirectionalHint,
  ContextualMenu,
  IDetailsList,
  Stack,
  Icon
} from "@fluentui/react";
import { connect, ConnectedProps } from "react-redux";
import authModule from "../../../../../../utilities/AuthModule";
import { LanguageContext } from "../../../../../../utilities/LocalizationModule";
import { columnSearchTypes, extensions, officeFileType, piiConfig, SharePointFolderContentTypeIds, sharePointInternalFileName } from "../../../../config/constants";
import { brandedCommandbarIconStyles, detailListStyles, detailRowPiiDetectedStyles, detailRowPiiNotDetectedStyles, detailRowStyles, menuItemIconStyles, previewWebPanelStyles } from "../../../../config/controlStyles";
import { ISearchOpenFileInfo } from "../../../../interfaces/ISearchOpenFileInfo";
import { RootState } from "../../../../redux";
import { getFileItemIdFromRelativePath, getItem, getItemCustomSelect, getItemWebViewUrl, getListItemWebUrl } from "../../../../services/GraphService";
import { ModeEnum } from "../../../enums/modeEnum";
import { DetailListSearchColumnSorterGrid } from "../../../helpers/DetailListSearchColumnSorterGrid";
import { RenderHelper } from "../../../helpers/renderHelper";
import { SearchOpenExtensionHelper } from "../../../helpers/SearchOpenExtensionHelper";
import { getExtension } from "../../../helpers/stringHelper";
import { EmailCreationTypeEnum } from "../../../enums/EmailCreationEnum";
import { IAdvancedSearchResult } from "../../../../../../advancedSearch/AdvancedSearchInterfaces";
import { IViewsDropdown } from "../../../../interfaces/IViewsDropdown";
import { SearchReturnType } from "../../../../../../advancedSearch/AdvancedSearchEnums";
import { IUrlKeyNamePair } from "../../../../interfaces/IUrlKeyNamePair";
import { IFileApproval } from "../../../_v2/components/Panels/AutomationPanel/AutomationPanel";
import dayjs from 'dayjs';
import { CMFileInfoPanel, InfoPanelMode } from "../../../../../../contentManager/Panels/CMFileInfoPanel";
import { WebPanel } from "../../../_v2/_shared/WebPanel/WebPanel";
import { CMFilePreviewPanel, MoveDirection, SearchSource } from "../../../../../../contentManager/Panels/CMFilePreviewPanel";
import { SharePointInputData } from "../../../../interfaces/props/SharePointInputData";
import { IDocUrlDropdown } from "../../../../interfaces/IDocUrlDropdown";
import { CMRenameModal } from "../../../../../../contentManager/Panels/CMRenameModal";
import { CMDeleteModal } from "../../../../../../contentManager/Panels/CMDeleteModal";
import { FileDownLoader } from "../../../helpers/fileDownloader";
import { tryEncodeUriComponent } from "../../../../../../utilities/EncodeDecode";
import advancedSearchStateManager from "../../../../../../advancedSearch/advancedSearchStateManager";
import { logger } from "../../../../../../utilities/logger";
import Loader from "../../../Loader";
import { OpenInBrowser, OpenPdfInBrowser } from "../../../../../../utilities/BrowserUtils";
import { OneDriveUrlHelper } from "../../../helpers/oneDriveUrlHelper";
import { IAuthAccount } from "../../../../interfaces/IAuthTokenResultDto";
import generalModule from "../../../../../../utilities/GeneralModule";
import { getFileNameDownloadTemplateAvailable, getFilenameFromTemplate } from "../../../../../../utilities/FileNameDownloadTemplateHelper";
import { CMFileSharePanel, SharePanelMode } from "../../../../../../contentManager/Panels/CMFileSharePanel";
import { detailsListClassNames } from "../../../../../../contentManager/Body/ContentBodyFilesFolders";
import { useRenameShortcut } from "../../../../../../contentManager/Body/hooks/useRenameShortcut";
import { FileIconType, getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import { iconDisplayStyle } from "../../../../styles/iconStyles";
import { getGridItemUrl } from "../../../helpers/UrlHelper";
import { Add20Filled } from "../../../_v2/components/SvgIcons/Add20Filled";
import { ArrowDownload20Regular } from "../../../_v2/components/SvgIcons/ArrowDownload20Regular";
import { Delete20Regular } from "../../../_v2/components/SvgIcons/Delete20Regular";
import { Dismiss20Regular } from "../../../_v2/components/SvgIcons/Dismiss20Regular";
import { DocumentArrowRight20Regular } from "../../../_v2/components/SvgIcons/DocumentArrowRight20Regular";
import { DocumentGlobe20Regular } from "../../../_v2/components/SvgIcons/DocumentGlobe20Regular";
import { DocumentLandscapeSplitHint20Regular } from "../../../_v2/components/SvgIcons/DocumentLandscapeSplitHint20Regular";
import { FlowDot20Regular } from "../../../_v2/components/SvgIcons/FlowDot20Regular";
import { Info20Regular } from "../../../_v2/components/SvgIcons/Info20Regular";
import { Link20Regular } from "../../../_v2/components/SvgIcons/Link20Regular";
import { List20Regular } from "../../../_v2/components/SvgIcons/List20Regular";
import { MailAttach20Regular } from "../../../_v2/components/SvgIcons/MailAttach20Regular";
import { MailLink20Regular } from "../../../_v2/components/SvgIcons/MailLink20Regular";
import { Open20Regular } from "../../../_v2/components/SvgIcons/Open20Regular";
import { OpenFolder20Regular } from "../../../_v2/components/SvgIcons/OpenFolder20Regular";
import { PreviewLink20Regular } from "../../../_v2/components/SvgIcons/PreviewLink20Regular";
import { RenameA20Regular } from "../../../_v2/components/SvgIcons/RenameA20Regular";
import { Share20Regular } from "../../../_v2/components/SvgIcons/Share20Regular";

export enum ResultType {
  all = -1,
  documentSet = 0,
  folder = 1,
  document = 2
}

export interface IResultTypeFilter {
  type: ResultType;
  extension?: string;
}

const mapStateToProps = (state: RootState) => {
  return {
    mode: state.mode.mode,
    user: state.user
  };
};

const connector = connect(mapStateToProps, undefined);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface SearchResultProp extends PropsFromRedux {
  searchResult: IAdvancedSearchResult;
  isLoading?: boolean;
  adjustHeightForBreakCrumb?: boolean,
  viewsDropdownItems: IViewsDropdown[],
  fields: any[],
  selectedSites: IUrlKeyNamePair[],
  allowOpenInSharePoint?: boolean,
  enablePII?: boolean,
  enableRedaction?: boolean,
  tenantEnableApprovalHooks?: boolean,
  isInConentMangerMode?: boolean,
  documentLibraries: IDocUrlDropdown[],
  openDocumentsInClientApp?: boolean,
  enableSharing?: boolean,
  recheckPii: (items: any, redactPiiData: boolean) => void,
  openApprovalsPanel: (items: any) => void,
  metaDataUpdated: (item: any, inputValuesToSave: SharePointInputData[]) => void;
  fileRenamed: (item: any, updatedValue: string) => void;
  filesDeleted: (selectedFiles: any[]) => void;
  filterCommandItem: ICommandBarItemProps;
  userAccount: IAuthAccount;
}

const SearchGrid: React.FunctionComponent<SearchResultProp> = props => {
  const languageStrings = React.useContext(LanguageContext);
  const [columns, setColumns] = React.useState<IColumn[]>([]);
  const [items, setItems] = React.useState([]);
  const [selectedItems, setSelectedItems] = React.useState({ items: [], count: 0 });
  const [selectedItemInfo, setSelectedItemInfo] = React.useState<ISearchOpenFileInfo>(null);
  const [groups, setGroups] = React.useState<IGroup[]>();
  const [selectedView, setSelectedView] = React.useState<IViewsDropdown>(null);
  const hasOneItemSelected = selectedItems.count === 1;
  const [topCommandItems, setTopCommandItems] = React.useState<ICommandBarItemProps[]>();
  const [topRightCommandItems, setTopRightCommandItems] = React.useState<ICommandBarItemProps[]>();
  const [contextMenuItems, setContextMenuItems] = React.useState<IContextualMenuItem[]>();
  const [waitFor, setWaitFor] = React.useState(false);
  const [isCMFileInfoPanelOpen, setIsCMFileInfoPanelOpen] = React.useState(false);
  const [isCMFilePreviewPanelOpen, setIsCMFilePreviewPanelOpen] = React.useState(false);

  const [selectedItem, setSelectedItem] = React.useState(null);
  const [selectedLibrary, setSelectedLibrary] = React.useState<IDocUrlDropdown>(null);

  const [showRenameDialog, setShowRenameDialog] = React.useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);

  // F2 = the Rename command. The command bar's own rename entry is the single
  // source of eligibility (canEdit, tenant disableFileRename, waitFor).
  const renameCommandItem = React.useMemo(() => topCommandItems?.find(item => item.key === "rename") ?? null, [topCommandItems]);
  const renameShortcutGridRef = useRenameShortcut(renameCommandItem);

  const [infoPanelMode, setInfoPanelMode] = React.useState<InfoPanelMode>();

  const detailsListRef = React.useRef<IDetailsList>();
  const mousePosition = React.useRef<Point>();
  const [openContextMenu, setOpenContextMenu] = React.useState<boolean>(false);
  const [contextualMenuProps, setContextualMenuProps] = React.useState<IContextualMenuProps>();
  const [resultTypes, setResultTypes] = React.useState<IResultTypeFilter[]>([]);
  const [selectedResultTypeFilter, setSelectedResultTypeFilter] = React.useState<IResultTypeFilter>({ type: ResultType.all });

  const resultTypeFilterContainerRef = React.useRef<HTMLDivElement>();

  const [isSharePanelOpen, setIsSharePanelOpen] = React.useState(false);
  const sharePanelModeRef = React.useRef<SharePanelMode>(SharePanelMode.Share);
  const openSharePanel = React.useCallback((mode: SharePanelMode) => {
    sharePanelModeRef.current = mode;
    setIsSharePanelOpen(true);
  }, []);

  const _getSelectionDetails = () => {
    setSelectedItems({ items: _selection.current.getSelection(), count: _selection.current.getSelectedCount() });
    if (_selection.current.count === 1) {
      let selectedItem: any = _selection.current.getSelection()[0];
      let extension = !selectedItem[columnSearchTypes.contentTypeId]?.startsWith(SharePointFolderContentTypeIds.folder)
        ? getExtension(selectedItem.name)
        : null;
      setSelectedItemInfo(SearchOpenExtensionHelper.determineOfficeFileType(extension));
      setSelectedItem(selectedItem);
    } else {
      setSelectedItemInfo(null);
      setSelectedItem(null);
    }
  };
  const _selection = React.useRef(new Selection({
    onSelectionChanged: _getSelectionDetails
  }));

  const IsOfficeJSAvailable = React.useRef<boolean>(typeof Office !== "undefined" && typeof Office.context?.diagnostics?.host !== "undefined");

  React.useEffect(() => {
    let selectedItems: any[] = [..._selection.current.getSelection()];

    let newSelectedItems: any[] = [];
    selectedItems.forEach(selectedItem => {
      const updatedSelectedItem = { ...selectedItem }
      const updatedRow = props.searchResult.result.find(x => x.driveId === updatedSelectedItem.driveid && x.webUrl === updatedSelectedItem.weburl);
      if (updatedRow) {
        updatedSelectedItem[piiConfig.privacySentitiveColumnName.toLowerCase()] = updatedRow[piiConfig.privacySentitiveColumnName]?.value;
      }
      newSelectedItems.push(updatedSelectedItem);
    });

    setSelectedItems({ items: [...newSelectedItems], count: newSelectedItems.length });

    getUniqueResultTypes(props.searchResult?.result);
  }, [props.searchResult]);

  React.useEffect(() => {
    if (!selectedView) {
      setGroups(null);
    }
    else if (selectedView && (!props.viewsDropdownItems?.some(view => view.webUrl === selectedView.webUrl) || props.searchResult.type === SearchReturnType.RecentItems)) {
      setSelectedView(null);
      setGroups(null);
    }
  }, [props.searchResult, props.viewsDropdownItems, selectedView]);

  React.useEffect(() => {
    if (openContextMenu) {
      const menuProps: IContextualMenuProps = {
        target: mousePosition.current,
        directionalHint: DirectionalHint.rightTopEdge,
        directionalHintFixed: true,
        items: contextMenuItems,
        onDismiss: () => {
          setOpenContextMenu(false);
          setContextualMenuProps(undefined);
        },
      };
      setContextualMenuProps(menuProps);
    }
  }, [openContextMenu, contextMenuItems]);

  const triggerContextMenu = (ev: any, position?: Point) => {
    mousePosition.current = position ? position : { left: ev.clientX, top: ev.clientY };
    setOpenContextMenu(true);
  }

  React.useEffect(() => {
    if (props.searchResult?.result) {
      const detailListBuilder: DetailListSearchColumnSorterGrid = new DetailListSearchColumnSorterGrid(triggerContextMenu, setColumns, setItems, setGroups, { name: languageStrings.Name, size: languageStrings.Size, modified: languageStrings.Modified, modifiedBy: languageStrings.ModifiedBy, unassigned: languageStrings.Unassigned, moreActions: languageStrings.MoreActions }, { openDocumentsInClientApp: props.openDocumentsInClientApp });
      detailListBuilder.setTableData(props.searchResult, selectedView, selectedResultTypeFilter, props.fields);
    }
  }, [props.searchResult, selectedView, selectedResultTypeFilter]);

  const viewItems: IContextualMenuItem[] = React.useMemo(() => {
    const dynamicViewItems = props.selectedSites
      ?.map((site, index) => {
        const siteHeader: IContextualMenuItem = {
          key: `site-${site.siteId}`,
          text: site.value,
          itemType: ContextualMenuItemType.Header
        };
        const siteViews: IContextualMenuItem[] = props.viewsDropdownItems
          .filter(view => view.siteId === site.siteId)
          .map((view) => {
            return ({
              disabled: !(props.searchResult.type == SearchReturnType.SearchResult),
              key: view.key as string,
              // iconProps: selectedView?.key === view.key ? { iconName: "Checkmark" } : null,
              canCheck: true,
              // checked: selectedView?.key === view.key,
              checked: selectedView?.webUrl === view.webUrl,
              text: view.text,
              onClick: () => setSelectedView(view),
            })
          });
        return siteViews?.length > 0 ? [siteHeader, ...siteViews] : []; //: [siteHeader, divider, ...siteViews]
      })
      .reduce((acc, val) => acc.concat(val), []);

    const defaultViewItem: IContextualMenuItem = {
      key: "defaultView",
      canCheck: true,
      checked: !selectedView,
      text: languageStrings.Default,
      onClick: () => setSelectedView(null)
    }

    return [defaultViewItem, ...dynamicViewItems];
  }, [props.selectedSites, props.viewsDropdownItems, props.searchResult, selectedView]);

  React.useEffect(() => {
    const topItems: ICommandBarItemProps[] = [];

    if (selectedItems.count === 0) {
      if (props.filterCommandItem) {
        topItems.push(props.filterCommandItem);
      }
    }
    else if (selectedItems.count === 1) {
      if (IsOfficeJSAvailable.current && props.mode !== ModeEnum.office) {
        topItems.push(
          {
            key: "email",
            disabled: waitFor === true,
            text: props.mode === ModeEnum.mailRead ? languageStrings.CreateEmail : languageStrings.AddEmail,
            // iconProps: { iconName: "Add" },
            iconProps: {},
            onRenderIcon: () => <Add20Filled className={menuItemIconStyles} />,
            subMenuProps: {
              items: [
                {
                  key: "attachment",
                  text:
                    props.mode === ModeEnum.mailRead ? languageStrings.CreateWithAttachments : languageStrings.AddAttachment,
                  // iconProps: { iconName: "Attach" },
                  iconProps: {},
                  onRenderIcon: () => <MailAttach20Regular className={menuItemIconStyles} />,
                  onClick: () => {
                    addShareableLink(true);
                  }
                },
                {
                  key: "link",
                  text:
                    props.mode === ModeEnum.mailRead
                      ? languageStrings.CreateWithShareableLinks
                      : languageStrings.AddShareableLink,
                  // iconProps: { iconName: "Share" },
                  iconProps: {},
                  onRenderIcon: () => <MailLink20Regular className={menuItemIconStyles} />,
                  onClick: () => {
                    addShareableLink();
                  }
                }
              ]
            }
          },
        )
      }

      if (!(selectedItemInfo?.type == officeFileType.Browser && props.allowOpenInSharePoint === false)) {
        topItems.push(
          {
            key: "open",
            disabled: waitFor === true,
            text: `${languageStrings.Open}`,
            // iconProps: { iconName: "FolderOpen" },
            iconProps: {},
            onRenderIcon: () => <Open20Regular className={menuItemIconStyles} />,
            subMenuProps: {
              items: getOpenButtonItems()
            }
          },
        )
      }

      if (props.enableSharing) {
        topItems.push(
          {
            key: "share",
            disabled: waitFor === true,
            text: `${languageStrings.Share}`,
            // iconProps: { iconName: "Share" },
            iconProps: {},
            onRenderIcon: () => <Share20Regular className={menuItemIconStyles} />,
            onClick: () => {
              openSharePanel(SharePanelMode.Share);
            }
          },
          {
            key: "copyLink",
            disabled: waitFor === true,
            text: `${languageStrings.CopyLink}`,
            // iconProps: { iconName: "Link" },
            iconProps: {},
            onRenderIcon: () => <Link20Regular className={menuItemIconStyles} />,
            onClick: () => {
              openSharePanel(SharePanelMode.Copy);
            }
          }
        )
      }

      if (selectedItem && selectedItem[columnSearchTypes.canEdit] && !advancedSearchStateManager.disableFileRename) {
        topItems.push(
          {
            key: "rename",
            disabled: !selectedItem || waitFor === true,
            text: `${languageStrings.RenameOnly}`,
            // iconProps: { iconName: "Rename" },
            iconProps: {},
            onRenderIcon: () => <RenameA20Regular className={menuItemIconStyles} />,
            onClick: () => {
              setShowRenameDialog(true);
            }
          },
        )
      }

      if (selectedItem
        && selectedItem[columnSearchTypes.canEdit]
        && (selectedItem[columnSearchTypes.checkoutUser] === props?.user?.account?.displayName || selectedItem[columnSearchTypes.checkoutUser] === '')
        && selectedItem.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder) !== true
        && selectedItem?.isdocument !== false) {
        topItems.push(
          {
            key: "replace",
            disabled: waitFor === true,
            text: `${languageStrings.ReplaceOnly}`,
            // iconProps: { iconName: "PostUpdate" },
            iconProps: {},
            onRenderIcon: () => <DocumentLandscapeSplitHint20Regular className={menuItemIconStyles} />,
            onClick: () => {
              setInfoPanelMode(InfoPanelMode.Replace);
              setSelectedLibrary(props.documentLibraries.find(x => x.driveId === selectedItem?.driveid));
              setIsCMFileInfoPanelOpen(true);
            }
          });
      }

      if (!selectedItems?.items?.some(x => x?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder))) {
        topItems.push(
          {
            key: "download",
            disabled: waitFor === true,
            text: `${languageStrings.Download}`,
            // iconProps: { iconName: "Download" },
            iconProps: {},
            onRenderIcon: () => <ArrowDownload20Regular className={menuItemIconStyles} />,
            onClick: () => {
              downloadFile();
            }
          }
        )
      }

      if (selectedItem && selectedItem[columnSearchTypes.canDelete] !== false) {
        topItems.push(
          {
            key: "delete",
            disabled: waitFor === true,
            text: `${languageStrings.Delete}`,
            // iconProps: { iconName: "Delete" },
            iconProps: {},
            onRenderIcon: () => <Delete20Regular className={menuItemIconStyles} />,
            onClick: () => {
              setShowDeleteDialog(true);
            }
          }
        )
      }

      // if (selectedItem && selectedItem[columnSearchTypes.canEdit] && props.enablePII &&
      //   !(selectedItems?.items?.every(x => x?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder))) &&
      //   selectedItems.items?.some(item => item && item[piiConfig.privacySentitiveColumnName.toLowerCase()] !== undefined) &&
      //   selectedItems.items?.some(item => item && item[piiConfig.privacySentitiveDataColumnName.toLowerCase()] !== undefined)
      // ) {
      //   topItems.push({
      //     key: "privacy",
      //     disabled: waitFor === true,
      //     text: languageStrings.PrivacySensitiveDisplay,
      //     iconProps: { iconName: "Unlock" },
      //     subMenuProps: {
      //       items: [
      //         {
      //           key: "link",
      //           text: languageStrings.Recheck,
      //           iconProps: { iconName: "Refresh" },
      //           onClick: () => {
      //             checkPii(false);
      //           }
      //         }
      //       ]
      //     }
      //   });

      //   addRedactButton(topItems);
      // }

      if (props.tenantEnableApprovalHooks && !selectedItems?.items?.some(x => x?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder))) {
        topItems.push(
          {
            key: "approvalHooks",
            disabled: waitFor === true,
            text: languageStrings.Automation,
            // iconProps: { iconName: "DocumentApproval" },
            iconProps: {},
            onRenderIcon: () => <FlowDot20Regular className={menuItemIconStyles} />,
            onClick: () => {
              openApprovalsPanel();
            }
          }
        )
      }

    }
    else if (selectedItems.count > 1) {
      if (IsOfficeJSAvailable.current && props.mode !== ModeEnum.office) {
        topItems.push(
          {
            key: "email",
            disabled: waitFor === true,
            text: props.mode === ModeEnum.mailRead ? languageStrings.CreateEmail : languageStrings.AddEmail,
            // iconProps: { iconName: "Add" },
            iconProps: {},
            onRenderIcon: () => <Add20Filled className={menuItemIconStyles} />,
            subMenuProps: {
              items: [
                {
                  key: "attachment",
                  text:
                    props.mode === ModeEnum.mailRead ? languageStrings.CreateWithAttachments : languageStrings.AddAttachment,
                  // iconProps: { iconName: "Attach" },
                  iconProps: {},
                  onRenderIcon: () => <MailAttach20Regular className={menuItemIconStyles} />,
                  onClick: () => {
                    addShareableLink(true);
                  }
                },
                {
                  key: "link",
                  text:
                    props.mode === ModeEnum.mailRead
                      ? languageStrings.CreateWithShareableLinks
                      : languageStrings.AddShareableLink,
                  // iconProps: { iconName: "Share" },
                  iconProps: {},
                  onRenderIcon: () => <MailLink20Regular className={menuItemIconStyles} />,
                  onClick: () => {
                    addShareableLink();
                  }
                }
              ]
            }
          }
        )
      }

      if (props.enableSharing) {
        topItems.push(
          {
            key: "copyLink",
            disabled: waitFor === true,
            text: `${languageStrings.CopyLink}`,
            // iconProps: { iconName: "Link" },
            iconProps: {},
            onRenderIcon: () => <Link20Regular className={menuItemIconStyles} />,
            onClick: () => {
              openSharePanel(SharePanelMode.Copy);
            }
          },
        )
      }

      if (!selectedItems?.items?.some(x => x?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder))) {
        topItems.push(
          {
            key: "download",
            disabled: waitFor === true,
            text: `${languageStrings.Download}`,
            // iconProps: { iconName: "Download" },
            iconProps: {},
            onRenderIcon: () => <ArrowDownload20Regular className={menuItemIconStyles} />,
            onClick: () => {
              downloadFile();
            }
          }
        )
      }

      if (!selectedItems?.items?.some(x => x?.candelete === false)) {
        topItems.push(
          {
            key: "delete",
            disabled: waitFor === true,
            text: `${languageStrings.Delete}`,
            // iconProps: { iconName: "Delete" },
            iconProps: {},
            onRenderIcon: () => <Delete20Regular className={menuItemIconStyles} />,
            onClick: () => {
              setShowDeleteDialog(true);
            }
          }
        )
      }

      // if (props.enablePII &&
      //   !(selectedItems?.items?.some(x => x?.canedit === false)) &&
      //   !(selectedItems?.items?.every(x => x?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder))) &&
      //   selectedItems.items?.some(item => item && item[piiConfig.privacySentitiveColumnName.toLowerCase()] !== undefined) &&
      //   selectedItems.items?.some(item => item && item[piiConfig.privacySentitiveDataColumnName.toLowerCase()] !== undefined)
      // ) {
      //   topItems.push({
      //     key: "privacy",
      //     disabled: waitFor === true,
      //     text: languageStrings.PrivacySensitiveDisplay,
      //     iconProps: { iconName: "Unlock" },
      //     subMenuProps: {
      //       items: [
      //         {
      //           key: "link",
      //           text: languageStrings.Recheck,
      //           iconProps: { iconName: "Refresh" },
      //           onClick: () => {
      //             checkPii(false);
      //           }
      //         }
      //       ]
      //     }
      //   });

      //   addRedactButton(topItems);
      // }

      if (props.tenantEnableApprovalHooks && !selectedItems?.items?.some(x => x?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder))) {
        topItems.push(
          {
            key: "approvalHooks",
            disabled: waitFor === true,
            text: languageStrings.Automation,
            // iconProps: { iconName: "DocumentApproval" },
            iconProps: {},
            onRenderIcon: () => <FlowDot20Regular className={menuItemIconStyles} />,
            onClick: () => {
              openApprovalsPanel();
            }
          }
        )
      }

    }

    setTopCommandItems(topItems);

    const propertiesItem: ICommandBarItemProps = {
      key: "info",
      disabled: !selectedItem || waitFor,
      // iconProps: { iconName: "Info" },
      iconProps: {},
      onRenderIcon: () => <Info20Regular className={menuItemIconStyles} />,
      iconOnly: true,
      tooltipHostProps: {
        content: <span>Info</span>
      },
      onClick: () => {
        setInfoPanelMode(InfoPanelMode.Update);
        setSelectedLibrary(props.documentLibraries.find(x => x.driveId === selectedItem?.driveid));
        setIsCMFileInfoPanelOpen(true);
      }
    };

    const previewItem: ICommandBarItemProps = {
      key: "preview",
      disabled: !selectedItem || waitFor || selectedItem.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder),
      // iconProps: { iconName: "PreviewLink" },
      iconProps: {},
      onRenderIcon: () => <PreviewLink20Regular className={menuItemIconStyles} />,
      iconOnly: true,
      tooltipHostProps: {
        content: <span>Preview</span>
      },
      onClick: () => {
        setIsCMFilePreviewPanelOpen(true);
      }
    };

    const initialSliceIndex: number = IsOfficeJSAvailable.current && props.mode !== ModeEnum.office ? 2 : 1;
    const contextItems: ICommandBarItemProps[] = [...topItems.slice(0, initialSliceIndex)];
    // Insert preview button below open options
    if (!previewItem.disabled) {
      contextItems.push({ ...previewItem, text: languageStrings.ShowPreview });
    }
    contextItems.push(...topItems.slice(initialSliceIndex));
    // Insert properties item last
    if (!propertiesItem.disabled) {
      contextItems.push({ ...propertiesItem, text: languageStrings.Properties });
    }
    setContextMenuItems(contextItems);

    // const topRightItems: ICommandBarItemProps[] = [
    //   {
    //     key: "views",
    //     disabled: !(props.searchResult.type == SearchReturnType.SearchResult) || waitFor === true,
    //     text: !selectedView ? languageStrings.Views : selectedView.text,
    //     iconProps: { iconName: "List" },
    //     subMenuProps: {
    //       items: viewItems
    //     }
    //   },
    //   propertiesItem,
    //   previewItem
    // ];
    const topRightItems: ICommandBarItemProps[] = [];

    if (viewItems?.length > 1) {
      topRightItems.push({
        key: "views",
        disabled: !(props.searchResult.type == SearchReturnType.SearchResult) || waitFor === true,
        text: !selectedView ? languageStrings.Views : selectedView.text,
        // iconProps: { iconName: "List" },
        iconProps: {},
        onRenderIcon: () => <List20Regular className={menuItemIconStyles} />,
        subMenuProps: {
          items: viewItems
        }
      });
    }
    topRightItems.push(propertiesItem);
    topRightItems.push(previewItem);

    if (selectedItems.count > 0 && !waitFor) {
      topRightItems.unshift({
        key: "selectedFileCount",
        text: `${selectedItems.count} ${languageStrings.Selected.toLowerCase()}`,
        disabled: waitFor === true,
        // iconProps: { iconName: "Clear" },
        iconProps: {},
        onRenderIcon: () => <Dismiss20Regular className={menuItemIconStyles} />,
        onClick: () => {
          _selection.current.setAllSelected(false);
          setSelectedItems({ items: _selection.current.getSelection(), count: _selection.current.getSelectedCount() });
        }
      })
    }

    if (waitFor === true) {
      topRightItems.unshift({
        key: "loadingFiles",
        text: `${languageStrings.LoadingOnly} ${selectedItems.count} ${selectedItems.count === 1 ? languageStrings.Item.toLowerCase() : languageStrings.Items.toLowerCase()}`,
        disabled: true,
        onRenderIcon: () => {
          return <Spinner size={SpinnerSize.small} style={{ paddingRight: 5 }} />
        }
      })
    }

    setTopRightCommandItems(topRightItems);

  }, [selectedItems, selectedItem, props?.searchResult, hasOneItemSelected, selectedItemInfo?.type, props?.allowOpenInSharePoint, props?.mode, viewItems, waitFor, props.userAccount]);

  const getUniqueResultTypes = (results: any[]) => {
    const resultTypes: IResultTypeFilter[] = [{ type: ResultType.all }];

    if (Array.isArray(results) && results.length > 0) {
      const documentSets = results.filter(res => res?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.documentSet));
      if (documentSets && documentSets.length > 0) {
        resultTypes.push({
          type: ResultType.documentSet
        });
      }

      const folders = results.filter(res => res?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) && !res?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.documentSet));
      if (folders && folders.length > 0) {
        resultTypes.push({
          type: ResultType.folder
        });
      }

      const extensions = new Set();
      results.forEach(res => {
        if (res?.name) {
          const fileExt: string = getExtension(res.name)?.toLowerCase();
          if (fileExt) {
            extensions.add(fileExt);
          }
        }
      });

      const extensionsList: string[] = Array.from(extensions) as string[];
      extensionsList?.forEach(ext => {
        resultTypes.push({
          type: ResultType.document,
          extension: ext
        })
      });
    }

    setResultTypes(resultTypes);
  }

  // const addRedactButton = (items: ICommandBarItemProps[]) => {
  //   if (props?.user?.tenantEnableRedaction) {

  //     let showRedactButton = false;
  //     selectedItems?.items.forEach(selectedFile => {
  //       if (
  //         getFileExtension(selectedFile.name) === extensions.pdf &&
  //         selectedFile[piiConfig.privacySentitiveColumnName.toLowerCase()] !== undefined &&
  //         selectedFile[piiConfig.privacySentitiveColumnName.toLowerCase()] === 'True'
  //       ) {
  //         showRedactButton = true;
  //       }
  //     });

  //     if (showRedactButton) {
  //       const privacyItem = items.find(x => x.key === 'privacy');

  //       if (privacyItem) {
  //         privacyItem.subMenuProps.items.push({
  //           key: "redact",
  //           text: languageStrings.Redact,
  //           iconProps: { iconName: "PageEdit" },
  //           onClick: () => {
  //             checkPii(true);
  //           }
  //         });
  //       }
  //     }
  //   }
  // }

  const downloadFile = async () => {
    setWaitFor(true);
    // await Promise.all(selectedItems.items.map(async (item) => {
    //   const itemId = await getFileItemIdFromRelativePath(await authModule.getGraphAccessToken(), item.driveid, item["serverrelativepath"]);
    //   const seletedDocumentLibrary = props.documentLibraries.find(x => x.driveId === item?.driveid)

    //   const results = await getItemByItemAndDriveID({
    //     driveId: item.driveid,
    //     siteUrl: seletedDocumentLibrary.webUrl,
    //     itemId,
    //     accessToken: await authModule.getSharePointAccessToken()
    //   }).unwrap();

    //   window.open(results['@content.downloadUrl'], "_blank");
    // }));
    try {
      const driveItems = await Promise.all(selectedItems.items.map(async (item) => {
        const driveId: string = item.driveid;
        const itemId: string = await getFileItemIdFromRelativePath(await authModule.getGraphAccessToken(), item.driveid, item["serverrelativepath"]);

        let fileName: string;

        if (getFileNameDownloadTemplateAvailable(advancedSearchStateManager.sites)) {
          const fileItem: any = await getItem(await authModule.getGraphAccessToken(), driveId, itemId);

          if (fileItem?.sharepointIds) {
            const fileNameFromTemplate: string = await getFilenameFromTemplate(
              advancedSearchStateManager.sites,
              driveId,
              itemId,
              fileItem.sharepointIds.siteUrl,
              fileItem.sharepointIds.listId,
              fileItem.sharepointIds.listItemUniqueId);

            if (fileNameFromTemplate) {
              fileName = fileNameFromTemplate;
            }
          }
        }

        if (!fileName) {
          fileName = item.FileLeafRef || item.name;
        }

        return {
          driveId: driveId,
          itemId: itemId,
          name: fileName
        };
      }));

      const downloadRequestPayload = {
        accessToken: await authModule.getGraphAccessToken(),
        items: driveItems
      };

      await FileDownLoader.downloadFileStream(downloadRequestPayload);
    } catch (error) {
      logger(error, "searchGrid.tsx (downloadFile)");
    }
    setWaitFor(false);
  }

  const getOpenButtonItems = () => {
    const isFolder: boolean = selectedItem?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder);

    const browser: IContextualMenuItem = {
      key: "browser",
      text: isFolder
        ? `${languageStrings.OpenIn} SharePoint`
        : `${languageStrings.OpenIn} ${languageStrings.Browser}`,
      // iconProps: { iconName: !isFolder ? "BrowserTab" : "SharepointLogo" },
      iconProps: {},
      onClick: () => {
        (async () => {
          if (selectedItem && getExtension(selectedItem.name)?.toLowerCase() === extensions.url) {
            try {
              const itemUrl = new URL(selectedItem[columnSearchTypes.webUrl]);
              const url = await getGridItemUrl(selectedItem, itemUrl.pathname + itemUrl.search, itemUrl.origin);
              window.open(url, "_blank");
              return;
            } catch (error) {
              // ignore
            }
          }

          setWaitFor(true);
          try {
            const graphAccessToken: string = await authModule.getGraphAccessToken();
            const item = selectedItems.items[0];
            const itemId: string = item.itemid ?? await getFileItemIdFromRelativePath(graphAccessToken, item.driveid, item["serverrelativepath"]);
            const url = await getItemWebViewUrl(
              graphAccessToken,
              item.driveid,
              itemId
            );
            setWaitFor(false);

            if (getExtension(item.name)?.toLowerCase() === extensions.pdf) {
              OpenPdfInBrowser((await authModule.getAccount(false)), item.driveid, itemId);
            }
            else {
              OpenInBrowser(url);
            }
          } catch (error) {
            logger(error, "searchGrid.tsx (open in browser)");
          }
        })();
      },
      // onRenderIcon: getOfficeFileTypeIcon,
      onRenderIcon: (props: IContextualMenuItemProps, defaultRender?: IRenderFunction<IContextualMenuItemProps>) => {
        return selectedItemInfo && selectedItemInfo.iconSrc
          ? <img src={selectedItemInfo.iconSrc} className={brandedCommandbarIconStyles} />
          : (!isFolder
            ? <DocumentGlobe20Regular className={menuItemIconStyles} />
            : <OpenFolder20Regular className={menuItemIconStyles} />);
      },
    };

    const app: IContextualMenuItem = selectedItem && getExtension(selectedItem.name)?.toLowerCase() !== extensions.url && {
      key: "app",
      text: `${languageStrings.OpenIn} ${languageStrings.App}`,
      // iconProps: { iconName: "CloneToDesktop" },
      iconProps: {},
      onClick: () => {
        (async () => {
          setWaitFor(true);
          try {
            const graphAccessToken = await authModule.getGraphAccessToken();
            const item = selectedItems.items[0];
            const driveId: string = item.driveid;
            const itemId: string = item.itemid ?? await getFileItemIdFromRelativePath(graphAccessToken, driveId, item["serverrelativepath"]);

            let openSelf: boolean = true;
            let url: string;
            if (!selectedItemInfo.isOfficeFile) {
              const file = driveId && itemId && await getItemCustomSelect(graphAccessToken, driveId, itemId, "name,sharepointIds");
              if (file?.sharepointIds) {
                const userEmail: string = props.userAccount?.username;
                const userId: string = props.userAccount?.uniqueId;
                const fileName: string = file.name;
                const fileId: string = file.sharepointIds.listItemUniqueId;
                const siteId: string = file.sharepointIds.siteId;
                const listId: string = file.sharepointIds.listId;
                const webUrl: string = file.sharepointIds.siteUrl;

                url = OneDriveUrlHelper.getOpenInOneDriveDesktopUrl(fileId, siteId, listId, userEmail, userId, webUrl, fileName);
              }
            }
            else {
              const webUrl: string = await getListItemWebUrl(graphAccessToken, item.driveid, itemId);
              url = `${selectedItemInfo.localUrlPrepended}${webUrl}`;

              if (!selectedItemInfo.localUrlPrepended) {
                openSelf = false;
              }
            }

            if (url) {
              OpenInBrowser(url, openSelf && generalModule.isInConentMangerMode());
            }
          } catch (error) {
            logger(error, "searchGrid.tsx (open in app)");
          }
          setWaitFor(false);
        })();
      },
      // onRenderIcon: getOfficeFileTypeIcon,
      onRenderIcon: (props: IContextualMenuItemProps, defaultRender?: IRenderFunction<IContextualMenuItemProps>) => {
        return selectedItemInfo && selectedItemInfo.iconSrc
          ? <img src={selectedItemInfo.iconSrc} className={brandedCommandbarIconStyles} />
          : <DocumentArrowRight20Regular className={menuItemIconStyles} />;
      }
    };

    let openOptions: IContextualMenuItem[];
    if (selectedItemInfo?.type == officeFileType.Browser) {
      openOptions = props.allowOpenInSharePoint === false
        ? []
        : [browser];
    }
    else {
      openOptions = [browser, app].filter(x => x);
    }
    return openOptions;
  };

  const getOfficeFileTypeIcon = React.useCallback((props: IContextualMenuItemProps, defaultRender?: IRenderFunction<IContextualMenuItemProps>) => {
    return selectedItemInfo && selectedItemInfo.iconSrc
      ? <img src={selectedItemInfo.iconSrc} className={brandedCommandbarIconStyles} />
      // : defaultRender({ ...props });
      : <OpenFolder20Regular className={menuItemIconStyles} />;
  }, [selectedItemInfo]);

  const addShareableLink = async (addsAsAttachments: boolean = false) => {
    setWaitFor(true);

    const result = await Promise.all(selectedItems.items.map(async (item) => {
      let pathParts = item.weburl.split("://")[1].split("/");
      for (let index = 0; index < pathParts.length; index++) {
        let urlPart = pathParts[index];
        pathParts[index] = tryEncodeUriComponent(urlPart.trim());
      }
      const encodedPath = `https://${pathParts.join("/")}`;
      return {
        id: item.itemid ?? await getFileItemIdFromRelativePath(await authModule.getGraphAccessToken(), item.driveid, item["serverrelativepath"]),
        driveId: item.driveid,
        name: item.name,
        webUrl: encodedPath
      };
    }));

    setWaitFor(false);

    Office.context.ui.messageParent(
      JSON.stringify({ data: result, type: addsAsAttachments === true ? EmailCreationTypeEnum.Attachments : EmailCreationTypeEnum.ShareableLinks })
    );
  };

  const checkPii = async (redactPiiData: boolean) => {
    props.recheckPii(selectedItems, redactPiiData);
  }

  const openApprovalsPanel = async () => {
    const approvalFiles = await Promise.all(selectedItems.items.map(async file => {
      const newFile: IFileApproval = {
        itemId: file.itemid,
        driveId: file.driveid,
        fileType: path.extname(file.name),
        modifiedBy: file.modifiedby ? file.modifiedby : file['modified by'],
        name: file.name,
        serverRelativePath: file["serverrelativepath"],
        lastModifiedDateTime: file.modifiedvalue ? file.modifiedvalue : dayjs.unix(file.modified).format("L")
      }

      if (file.privacysensitive) {
        if (file.privacysensitive === 'True') {
          return {
            ...newFile,
            pii: {
              piiDetected: true,
              pii: file.privacysensitivedata
            }
          };

        } else {
          return {
            ...newFile,
            pii: {
              piiDetected: false,
              pii: file.privacysensitivedata
            }
          };
        }
      }
      return newFile;
    }));

    props.openApprovalsPanel(approvalFiles);
  }

  // const calculateHeight = () => {
  //   if (props.adjustHeightForBreakCrumb) {
  //     // return displayHeight;
  //     return "calc(100vh - 212px)"
  //   }
  //   return "calc(100vh - 174px)";
  // }
  const calculateHeight = () => {
    if (props.adjustHeightForBreakCrumb) {
      // return displayHeight;
      return `calc(100vh - ${152 + (resultTypeFilterContainerRef.current?.offsetHeight ?? 0)}px)`;
    }
    return `calc(100vh - ${104 + (resultTypeFilterContainerRef.current?.offsetHeight ?? 0)}px)`;
  };

  const metaDataUpdateSuccess = (item: any, inputValuesToSave: SharePointInputData[], selectedContentTypeId: string, extention: string) => {
    const updatedItem = { ...item };

    updatedItem.contenttypeid = selectedContentTypeId;

    inputValuesToSave.forEach(inputValue => {
      if (inputValue.internalName === sharePointInternalFileName) {
        updatedItem.name = `${inputValue.value}${extention ? `.${extention}` : ''}`;
      } else {
        // updatedItem[inputValue.internalName.toLowerCase()] = inputValue.value;
        const propertyInternalName: string = inputValue.internalName.trim().toLowerCase();
        updatedItem[propertyInternalName.replaceAll("_x0020_", " ")] = inputValue.value;
      }
    });

    setSelectedItem(updatedItem);

    setIsCMFileInfoPanelOpen(false);
    props.metaDataUpdated(item, inputValuesToSave);
  }

  const fileRenameSuccess = (item: any, updatedValue: string) => {
    const updatedItem = { ...item };
    updatedItem.name = updatedValue;

    setSelectedItem(updatedItem);
    setShowRenameDialog(false);

    props.fileRenamed(item, updatedValue);
  }

  const deleteSuccess = () => {
    setShowDeleteDialog(false);

    _selection.current.setAllSelected(false);
    setSelectedItems({ items: _selection.current.getSelection(), count: _selection.current.getSelectedCount() });

    props.filesDeleted(selectedItems.items);
  }

  // const classNames = mergeStyleSets({
  //   wrapper: {
  //     height: calculateHeight(),
  //     position: "relative",
  //   }
  // });
  const classNames = mergeStyleSets({
    wrapper: {
      height: calculateHeight(),
      position: "relative",
    }
  });

  const commandBarStyle: Partial<ICommandBarStyles> = {
    root: { paddingLeft: "10px", paddingTop: "10px" }
  };

  const _onRenderRow: IDetailsListProps['onRenderRow'] = rowProps => {
    const privacySensitive = rowProps.item[piiConfig.privacySentitiveColumnName.toLowerCase()];
    const privacySensitiveData = rowProps.item[piiConfig.privacySentitiveDataColumnName.toLowerCase()];

    let rowStyles: Partial<IDetailsRowStyles> = { ...detailRowStyles };

    if (props.enablePII && privacySensitive !== undefined) {
      if (privacySensitive === 'True') {
        rowStyles = { ...detailRowPiiDetectedStyles }
      }
      else if (privacySensitiveData === "-") {
        rowStyles = { ...detailRowPiiNotDetectedStyles }
      }
    }

    return <DetailsRow {...rowProps} className={detailsListClassNames.row} styles={rowStyles} />;
  };

  const getSelectedIndex = React.useCallback(() => {
    const selectedIndices: number[] = _selection.current?.getSelectedIndices();
    if (Array.isArray(selectedIndices) && selectedIndices.length > 0 && Array.isArray(items) && items.length > 0) {
      return selectedIndices[0];
    }
    return -1;
  }, [items]);

  const move = React.useCallback((direction: MoveDirection) => {
    const currentSelectedIndex: number = getSelectedIndex();
    if (currentSelectedIndex !== -1) {
      let nextSelectedIndex: number;
      if (direction === MoveDirection.Back) {
        nextSelectedIndex = currentSelectedIndex - 1;
      }
      else {
        nextSelectedIndex = currentSelectedIndex + 1;
      }

      if (Array.isArray(items) && (items.length - 1) >= nextSelectedIndex) {
        _selection.current.setAllSelected(false);
        _selection.current.setIndexSelected(nextSelectedIndex, true, true);
        detailsListRef.current?.focusIndex(nextSelectedIndex);
      }
    }
  }, [items]);

  const defaultShimmerColumns: IColumn[] = React.useMemo(() => {
    const columns: IColumn[] = [
      { key: "0", name: "", minWidth: 16, maxWidth: 16 },
      { key: "1", name: languageStrings.Name, minWidth: 200 },
      { key: "2", name: languageStrings.Modified, minWidth: 150 },
      { key: "3", name: languageStrings.Size, minWidth: 150 },
      { key: "4", name: languageStrings.ModifiedBy, minWidth: 150 }];
    return columns;
  }, []);

  const getIsPreviewNotSupported = () => {
    try {
      return selectedItem?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder) === true || selectedItem?.isdocument === false;
    } catch (error) {
      // ignore
    }
    return false;
  }

  const detailList = (
    <>
      {items?.length === 0 && props.isLoading ? <Loader label={languageStrings.RetrievingInfo} /> :
        <>
          <div ref={resultTypeFilterContainerRef} style={{ maxWidth: "calc(100vw - 380px)", overflowX: "auto", paddingTop: props.adjustHeightForBreakCrumb ? 5 : 15 }}>
            <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 15 }} style={{ marginBottom: 5, marginLeft: 10 }} >
              {selectedResultTypeFilter && resultTypes?.length > 0 && resultTypes.map((item, index) => {
                return (
                  <Stack.Item key={index}
                    className={`home-filter-icon-container ${selectedResultTypeFilter?.extension === item?.extension && selectedResultTypeFilter?.type === item?.type ? "home-filter-icon-container-active" : ""}`}
                    onClick={() => setSelectedResultTypeFilter(item)}
                  >
                    {item.type === ResultType.all && (
                      <Stack.Item className="home-filter-icon-container-text-all">
                        <div>{languageStrings.All}</div>
                      </Stack.Item>
                    )}
                    {item.type === ResultType.documentSet && (
                      <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                        <Stack.Item className="home-filter-icon-container-icon">
                          <Icon {...getFileTypeIconProps({ type: FileIconType.docset, size: 20, imageFileType: "svg" })} styles={iconDisplayStyle} />
                        </Stack.Item>
                        <Stack.Item className="home-filter-icon-container-text">
                          {"Document Sets"}
                        </Stack.Item>
                      </Stack>
                    )}
                    {item.type === ResultType.folder && (
                      <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                        <Stack.Item className="home-filter-icon-container-icon">
                          <Icon {...getFileTypeIconProps({ type: FileIconType.folder, size: 20, imageFileType: "svg" })} styles={iconDisplayStyle} />
                        </Stack.Item>
                        <Stack.Item className="home-filter-icon-container-text">
                          {languageStrings.Folders}
                        </Stack.Item>
                      </Stack>
                    )}
                    {item.type === ResultType.document && item.extension && (
                      <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                        <Stack.Item className="home-filter-icon-container-icon">
                          <Icon
                            {...getFileTypeIconProps({
                              extension: item.extension,
                              size: 20,
                              imageFileType: "svg"
                            })}
                          />
                        </Stack.Item>
                        <Stack.Item className="home-filter-icon-container-text">
                          {item.extension}
                        </Stack.Item>
                      </Stack>
                    )}
                  </Stack.Item>
                )
              })}
            </Stack>
          </div>
          <CommandBar
            styles={commandBarStyle}
            // items={IsOfficeJSAvailable ? topCommandItems : topCommandItems?.filter(i => i.key.toLowerCase() !== "email")}
            items={topCommandItems}
            ariaLabel="Use left and right arrow keys to navigate between commands"
            farItems={topRightCommandItems}
          />
          <div className={classNames.wrapper} ref={renameShortcutGridRef}>
            <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
              <ShimmeredDetailsList
                componentRef={detailsListRef}
                styles={detailListStyles}
                onRenderRow={_onRenderRow}
                compact={false}
                items={items}
                columns={columns?.length > 0 ? columns : defaultShimmerColumns}
                selectionMode={SelectionMode.multiple}
                constrainMode={ConstrainMode.unconstrained}
                onRenderDetailsHeader={RenderHelper.onRenderDetailsHeader}
                onItemContextMenu={(item?: any, index?: number, ev?: MouseEvent) => triggerContextMenu(ev)}
                setKey="multiple"
                enableShimmer={props.isLoading}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                selectionPreservedOnEmptyClick={true}
                selection={_selection.current}
                ariaLabelForSelectionColumn="Toggle selection"
                ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                checkButtonAriaLabel="Row checkbox"
                className="xb-search-grid"
                groups={groups?.length > 0 ? groups : null}
              />
              {contextualMenuProps && <ContextualMenu {...contextualMenuProps} />}
            </ScrollablePane>
          </div>
        </>
      }
      {isCMFileInfoPanelOpen && selectedItems.count === 1 && <CMFileInfoPanel panelIsOpen={isCMFileInfoPanelOpen} closeOnSuccess={metaDataUpdateSuccess} closePanel={() => setIsCMFileInfoPanelOpen(false)} item={!selectedItem.sharepointIds && selectedItem} webAddinItem={selectedItem.sharepointIds && selectedItem} selectedDocumentLibrary={selectedLibrary} infoPanelMode={infoPanelMode} />}
      {isCMFilePreviewPanelOpen && <WebPanel isOpen={isCMFilePreviewPanelOpen} width="1100px" closePanel={() => setIsCMFilePreviewPanelOpen(false)} headerText={selectedItem?.name} styles={previewWebPanelStyles}>
        {selectedItems.count === 1 && <CMFilePreviewPanel selectedItem={selectedItem} searchSource={SearchSource.Api} totalItemCount={items?.length} selectedItemIndex={getSelectedIndex()} previewNotSupported={getIsPreviewNotSupported()} move={move} />}
      </WebPanel>}
      {showRenameDialog && <CMRenameModal showDialog={showRenameDialog} closeDialog={() => setShowRenameDialog(false)} selectedItem={selectedItem} closeOnSuccess={fileRenameSuccess} isAdvancedSearch={true} selectedDocumentLibraries={props.documentLibraries} />}
      {showDeleteDialog && <CMDeleteModal showDialog={showDeleteDialog} closeDialog={() => setShowDeleteDialog(false)} selectedItems={selectedItems?.items} selectedDocumentLibraries={props.documentLibraries} closeOnSuccess={() => deleteSuccess()} />}
      {isSharePanelOpen && <CMFileSharePanel panelIsOpen={isSharePanelOpen} closePanel={() => setIsSharePanelOpen(false)} items={selectedItems?.items} mode={sharePanelModeRef.current} hideSharingInfo={true} userAccount={props.userAccount} />}
    </>
  );

  return detailList;
};

export default connector(SearchGrid);
